import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { ENV_TOKEN } from '../../app-module.token';

@Component({
  selector: 'oaj-busqueda-autoridades',
  templateUrl: './dashboard-autoridades.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardAutoridadesComponent implements OnInit {

  apiUrl = "";
  readonly environment = inject(ENV_TOKEN);
  
  ngOnInit() {
    this.apiUrl = this.environment.apiBaseUrl + this.environment.api;
  }

}